import { themeGet } from '@styled-system/theme-get'
import { Box } from 'pcln-design-system'
import styled from 'styled-components'

export const StyledRelative = styled(Box)`
  position: relative;
  overflow: hidden;
`

export const StyledAbsolute = styled(Box)`
  position: absolute;
  top: ${themeGet('space.4')}px;
  right: ${themeGet('space.3')}px;
`
